export default (() => {
  if (window.pageSettings.editmode) return

  const modals = document.querySelectorAll('[data-modal-trigger]')
  if (modals.length) {
    import(/* webpackPrefetch: 0 */ './module')
      .then((mod) => mod.default(modals))
      .catch((err) => console.log(err))
  }
})()